import  MainMenu from "./MainMenu";
import SecondaryMenu from "./SecondaryMenu";
import Tabs from "./Tabs";


const SettingsHeader = ({
  activeItem,
  setActiveItem
}) => {

  const logoImage = () => {
    return window.thhaAdminSettings.assets_url + 'img/huge-addons-logo.svg';
  }
  return(
    <div className="header-wrapper">
      <div className="header-left">
        <div className="icon"><img src={logoImage()} className="logo-image" alt="Huge Addons Logo" /></div>
        <MainMenu 
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
      </div>
      <SecondaryMenu />
    </div>
  )
}
export default SettingsHeader;